// abdalmalek local
export const BASE_URL = 'https://exam-demo-api.edunixsystem.com'
// export const BASE_URL = 'http://beeserver:9595'
// export const BASE_URL = 'http://192.168.88.118:5000'
// export const BASE_URL = 'http://localhost:5000'

// Client mirror
// export const BASE_URL = 'https://exam-api.almarah-school.edunixsystem.com'

export const A4Dimensions = {
	CM: { WIDTH: 21, HEIGHT: 29.7 },
	MM: { WIDTH: 210, HEIGHT: 297 },
	INCH: { WIDTH: 8.27, HEIGHT: 11.69 },
}